import React, { useMemo } from 'react';
import { CheckCircle2, AlertTriangle, XCircle } from 'lucide-react';
import WorkflowUtilityPanel from './WorkflowUtilityPanel';
import { runWorkflowChecklist } from '../../utils/workflowBuilderUtils';
import { cn } from '../../lib/utils';

const STATUS_ICON = {
  pass: CheckCircle2,
  warning: AlertTriangle,
  error: XCircle,
};

const STATUS_STYLE = {
  pass: 'text-emerald-600',
  warning: 'text-amber-600',
  error: 'text-red-600',
};

const WorkflowValidationPanel = ({ workflow, onClose }) => {
  const checks = useMemo(() => runWorkflowChecklist(workflow), [workflow]);

  return (
    <WorkflowUtilityPanel title="Workflow checklist" onClose={onClose} testId="workflow-validation-panel">
      <div className="space-y-2">
        {checks.map((check) => {
          const Icon = STATUS_ICON[check.status] || AlertTriangle;
          return (
            <div
              key={check.id}
              className="flex items-start gap-2 rounded-lg border border-slate-100 px-3 py-2"
              data-testid={`checklist-item-${check.id}`}
            >
              <Icon size={16} className={cn('mt-0.5 shrink-0', STATUS_STYLE[check.status])} />
              <div>
                <p className="text-sm font-medium text-slate-900">{check.label}</p>
                {check.message && <p className="text-xs text-slate-500">{check.message}</p>}
              </div>
            </div>
          );
        })}
      </div>
    </WorkflowUtilityPanel>
  );
};

export default WorkflowValidationPanel;
